export default "__VITE_ASSET__Ch1F4PMQ__"